import { defineComponent as _defineComponent } from 'vue'
import { useStore } from "@nuxtjs/composition-api";
import { computed, onMounted } from "vue";

import { useCreatorShopRecentProducts } from "@/composables/creator-shop";
import { getExperimentsStore } from "@/store/experiments";
import {
  EXPERIMENTS_CREATOR_GIFT_GUIDES,
  FEATURE_FLAG_ACTIVE,
  FLAG_CREATOR_SHOP_SEARCH,
} from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopProductsTab',
  props: {
  profileId: { type: String, required: true },
  displayName: { type: String, required: true },
  isVisible: { type: Boolean, required: true, default: false },
  hasPosts: { type: Boolean, default: false },
  hasProductsSets: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const store = useStore();
const experimentsStore = getExperimentsStore(store);

const { searchTerm, showLoading, showError, productIds, onFetchProducts, onFetchMoreProducts } =
  useCreatorShopRecentProducts(props.profileId);

const isCreatorShopSearchEnabled = computed(
  () => experimentsStore.flag(FLAG_CREATOR_SHOP_SEARCH)?.value === FEATURE_FLAG_ACTIVE,
);

onMounted(() => {
  if (isCreatorShopSearchEnabled.value) {
    onFetchProducts();
  }
});

return { __sfc: true,props, store, experimentsStore, searchTerm, showLoading, showError, productIds, onFetchProducts, onFetchMoreProducts, isCreatorShopSearchEnabled, EXPERIMENTS_CREATOR_GIFT_GUIDES }
}

})